/* global width:true */
import React from "react";

import CardImageType1 from "../../molecules/card-image-type-1/index";
import CardImageType2 from "../../molecules/card-image-type-2";
import CardImageType2WoImage from "../../molecules/card-image-type-2-wo-image";

import { object, number, array } from "prop-types";

import "./organism-1.m.css";

const Organism1 = ({ collection, headlineLimit, widths = [250, 480, 764] }) => {
  const collectionStories = collection.items ? collection.items : [];
  const [firstStory, secondStory, ...restOftheStories] = collectionStories.filter(item => item.type === "story");

  const renderOtherStories = restOftheStories
    .slice(0, 4)
    .map(
      (story, index) =>
        width && width >= 768 ? (
          <CardImageType2WoImage story={story.story} key={index} headlineLimit={headlineLimit} />
        ) : (
          <CardImageType2 story={story.story} key={index} headlineLimit={headlineLimit} widths={widths} />
        )
    );

  return (
    <div styleName="wrapper">
      <div styleName="group-1">
        {firstStory && <CardImageType1 story={firstStory.story} headlineLimit={headlineLimit} />}
        {secondStory &&
          (width && width >= 768 ? (
            <CardImageType2WoImage story={secondStory.story} headlineLimit={headlineLimit} />
          ) : (
            <CardImageType2 story={secondStory.story} headlineLimit={headlineLimit} widths={widths} />
          ))}
      </div>
      <div styleName="group-2">{renderOtherStories}</div>
    </div>
  );
};

export default Organism1;

Organism1.propTypes = {
  collection: object,
  headlineLimit: number,
  widths: array
};
